import ready from './ready';

function handleReadMoreClick(link, description) {
  description.classList.toggle('is-hidden');
  link.innerText = link.innerText === 'Read more' ? 'Read less' : 'Read more';
}

function initLongDescriptions() {
  const longDescriptions = document.getElementsByClassName('js-long-description');

  for (var i = 0; i < longDescriptions.length; i++) {
    const description = longDescriptions[i];
    const link = document.createElement('a');
    link.classList.add('read-more', 'js-read-more');
    link.addEventListener('click', () => handleReadMoreClick(link, description));
    const text = document.createTextNode("Read more");
    link.appendChild(text);

    description.insertAdjacentElement('beforebegin', link);
  }
}

//ready(initLongDescriptions);



// WEBPACK FOOTER //
// ./assets/js/main.js